import React from 'react';

import {
	Spinner,
} from '@components';

import {
	useClassNames,
} from '@common';

import './Skeleton.scss';

interface SkeletonProps {
	className?: string,
	leading?: JSX.Element,
	content: JSX.Element | string,
	trailing?: JSX.Element,
}

function Skeleton(props: SkeletonProps): JSX.Element {
	const {
		className,
		leading = <Spinner />,
		trailing,
		content,
	} = props;

	const classes = useClassNames(
		'skeleton',
		className,
	);

	return (
		<div className={classes}>
			<div className="skeleton__leading">
				{leading}
			</div>
			<div className="skeleton__content">
				{content}
			</div>
			<div className="skeleton__trailing">
				{trailing}
			</div>
		</div>
	);
}

const MemoisedSkeleton = React.memo(Skeleton);

export {MemoisedSkeleton as Skeleton};